// @flow
/** @jsx jsx */

import { memoize } from 'lodash';

import { SearchableSelectField } from '@zapier/common-components';
import { jsx } from '@emotion/core';
import { weightedSearch } from '@zapier/common-utils';

import usStates from './usStates';

const stateSearch = memoize(weightedSearch);

type Props = {
  /** Show Error Styling */
  hasError?: boolean,
  /** Id of label element */
  labelId?: string,
  /** Handle item change */
  onChange: (event: SyntheticEvent<HTMLInputElement> | string) => void,
  /** Initial value */
  value?: string,
};

const StateSelect = ({ hasError, labelId, onChange, value }: Props) => {
  const initialValue = value ? usStates.find(c => c.code === value) : null;
  return (
    <SearchableSelectField
      autoComplete="shipping address-level1"
      filterItems={stateSearch}
      getKeyForItem={item => item.code}
      getLabelForItem={item => item.name}
      hasError={hasError}
      initialSelectedItem={initialValue}
      items={usStates}
      labelId={labelId}
      menuAriaLabel="address states"
      name="addressState"
      onChange={onChange}
      placeholder="Select a state..."
    />
  );
};

export default StateSelect;
